import React from "react";
import { AppState } from "../system/AppState";

export const AppStateContext = React.createContext<AppState>(null as unknown as AppState);

export const AppStateProvider = AppStateContext.Provider;
